import React from 'react'

import MicrocmsImage from '@atoms/MicrocmsImage'
import Link from '@atoms/Link'
import JumpLink from '@molecules/JumpLink'
import { useTranslation } from '@models/Translation'
import { Parent, convertPlainTitle } from '@models/Parent'

import * as style from './style.module.sass'

type SeriesSummaryProps = {
  series: Parent
}
const SeriesSummary: React.FC<SeriesSummaryProps> = ({ series }) => {
  const { t, locale } = useTranslation()

  return (
    <article className={style.card}>
      <Link className={style.image} to={series.path}>
        <MicrocmsImage
          image={series.image}
          alt={convertPlainTitle(series.title, locale)}
          type="hero"
        />
      </Link>
      <div className={style.content}>
        {series.writer != null && (
          <div className={style.writer}>by: {series.writer}</div>
        )}
        <h3
          className={style.head}
          dangerouslySetInnerHTML={{ __html: series.title }}
        />
        <div
          className={style.description}
          dangerouslySetInnerHTML={{ __html: series.contents }}
        />
        <div className={style.more}>
          <JumpLink to={series.path}>{t('articles')}</JumpLink>
        </div>
      </div>
    </article>
  )
}

export default SeriesSummary
